import { render, staticRenderFns } from "./About.vue?vue&type=template&id=045f7ebe&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseSectionHeading: require('/opt/buildhome/repo/components/base/SectionHeading.vue').default,Mailgo: require('/opt/buildhome/repo/components/mailgo.vue').default,LocationButton: require('/opt/buildhome/repo/components/LocationButton.vue').default,BaseSection: require('/opt/buildhome/repo/components/base/Section.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VResponsive,VRow})
